import { Render, RenderText } from '@9gustin/react-notion-render'
import classNames from 'classnames'
import { useState } from 'react'

import type { NotionBlock, Text } from '@9gustin/react-notion-render'
import type { ReactElement } from 'react'

import './styles.scss'

interface Props {
  blocks: NotionBlock[]
  texts?: Text[]
}

const ListItem = ({ blocks, texts }: Props): ReactElement => {
  const [isClicked, setIsClicked] = useState(false)

  const buttonClassName = classNames('notion-focusable', { clicked: isClicked })

  const handleToggle = () => {
    setIsClicked(!isClicked)
  }

  return (
    <div className="notion-list-item">
      <div className="toggle-title">
        <div className={buttonClassName} onClick={handleToggle} role="button">
          <svg className="triangle" viewBox="0 0 100 100">
            <polygon points="5.9,88.2 50,11.8 94.1,88.2 "></polygon>
          </svg>
        </div>
        {texts ? texts.map((text, index) => <div key={`toggle-title-${index}`}>{RenderText(text)}</div>) : null}
      </div>
      {isClicked && <Render blocks={blocks} simpleTitles useStyles />}
    </div>
  )
}

export default ListItem
